import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5","key":"svg-0"}],["path",{"d":"M15 12v6.5a2.5 2.5 0 1 1 -5 0v-.5","key":"svg-1"}],["path",{"d":"M12 9h6.5a2.5 2.5 0 1 1 0 5h-.5","key":"svg-2"}],["path",{"d":"M9 12v-6.5a2.5 2.5 0 0 1 5 0v.5","key":"svg-3"}]]

const IconApiApp = createReactComponent('outline', 'api-app', 'ApiApp', __iconNode);

export default IconApiApp;